module.exports = __webpack_public_path__ + "static/img/dontomas-logo.34026d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dontomas-logo.gif
// module id = 132
// module chunks = 1